export var FullStoryCustomEventName;
(function (FullStoryCustomEventName) {
    FullStoryCustomEventName["TS_API_REQUEST"] = "TS_API_REQUEST";
    FullStoryCustomEventName["ERROR_PAGE_SHOWN"] = "ERROR_PAGE_SHOWN";
    FullStoryCustomEventName["LARGEST_CONTENTFUL_PAINT"] = "LARGEST_CONTENTFUL_PAINT";
})(FullStoryCustomEventName || (FullStoryCustomEventName = {}));
export var FullStoryAPIEventProp;
(function (FullStoryAPIEventProp) {
    FullStoryAPIEventProp["REQUEST_URL"] = "request_url_str";
    FullStoryAPIEventProp["PRISM_OP_NAME"] = "prism_operation_name_str";
    FullStoryAPIEventProp["RESPONSE_STATUS"] = "response_status_int";
    FullStoryAPIEventProp["PRISM_TRACE_ID"] = "prism_trace_id_str";
    FullStoryAPIEventProp["DURATION_MS"] = "duration_ms_real";
    FullStoryAPIEventProp["PRISM_ONLY_LATENCY_MS"] = "prism_only_latency_ms_real";
    FullStoryAPIEventProp["PRISM_TOTAL_LATENCY_MS"] = "prism_total_latency_ms_real";
    FullStoryAPIEventProp["RESPONSE_SIZE_BYTES"] = "response_size_bytes_real";
    FullStoryAPIEventProp["BASE_RELEASE_VER"] = "base_release_version_str";
    FullStoryAPIEventProp["ERROR_DETAILS"] = "error_details";
    FullStoryAPIEventProp["ERROR_MESSAGE"] = "message_str";
    FullStoryAPIEventProp["ERROR_CODE"] = "code_str";
    FullStoryAPIEventProp["ERROR_SERVICE"] = "service_str";
})(FullStoryAPIEventProp || (FullStoryAPIEventProp = {}));
export var FullStoryErrorPageEventProp;
(function (FullStoryErrorPageEventProp) {
    FullStoryErrorPageEventProp["ERROR_MESSAGE"] = "error_message_str";
})(FullStoryErrorPageEventProp || (FullStoryErrorPageEventProp = {}));
export var FullStoryLargestContentfulPaintEventProp;
(function (FullStoryLargestContentfulPaintEventProp) {
    FullStoryLargestContentfulPaintEventProp["LARGEST_CONTENTFUL_PAINT"] = "largest_contentful_paint_ms_real";
    FullStoryLargestContentfulPaintEventProp["EVENT_LABEL"] = "event_label_str";
})(FullStoryLargestContentfulPaintEventProp || (FullStoryLargestContentfulPaintEventProp = {}));
export const PRISM_OP_NAMES_TO_SKIP = [
    'isSessionActive',
    'HasProfilePic',
    'GetAnswerV2WithDecodedViz',
];
export const FETCH_PROMISE_REJECTED = 'FETCH PROMISE REJECTED';
export const REQUEST_TIMEOUT_STATUS_CODE = 408;
export var FullStoryIdentifyUserProp;
(function (FullStoryIdentifyUserProp) {
    FullStoryIdentifyUserProp["BASE_RELEASE_VER"] = "base_release_version_str";
    FullStoryIdentifyUserProp["FULL_RELEASE_VER"] = "full_release_version_str";
    FullStoryIdentifyUserProp["USER_PERSONA"] = "user_persona_str";
    FullStoryIdentifyUserProp["ORG_ID"] = "org_id_str";
    FullStoryIdentifyUserProp["CLUSTER_ID"] = "cluster_id_str";
    FullStoryIdentifyUserProp["USER_LOCALE"] = "user_locale_str";
    FullStoryIdentifyUserProp["TRIAL_EXPIRY_DATE"] = "trial_expiry_str";
    FullStoryIdentifyUserProp["PLAN_TYPE"] = "plan_type_str";
    FullStoryIdentifyUserProp["TEAM_ID"] = "team_id_str";
    FullStoryIdentifyUserProp["EMAIL_ID"] = "email_id_str";
})(FullStoryIdentifyUserProp || (FullStoryIdentifyUserProp = {}));
export const FULLSTORY_ORG_ID = '15398T';
export const MILLISECOND_PRECISION = 2;
export const PRISM_ONLY = 'prism-only';
export const PRISM_TOTAL = 'prism-total';
export const PRISM_TRACE_ID_HEADER_NAME = 'x-prism-trace-id';
//# sourceMappingURL=fullstory-constants.js.map